import { render } from "./SliderItem.vue?vue&type=template&id=fabc6d9c&scoped=true"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"

import "./SliderItem.vue?vue&type=style&index=0&id=fabc6d9c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabc6d9c"]])

export default __exports__